import { render, staticRenderFns } from "./KecamatanV2.vue?vue&type=template&id=471fb847"
import script from "./KecamatanV2.vue?vue&type=script&lang=js"
export * from "./KecamatanV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports